import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Urbaniahireinpune() {



  const cardData = {
"keyword": "Urbania Hire in Pune",

"headingDescription":
  "Shivai Travels offers reliable Urbania hire in Pune for comfortable group travel including family trips, corporate tours, wedding transportation, airport transfers, pilgrimage journeys, and outstation travel across Maharashtra and India. Our Force Urbania vehicles are designed for premium comfort with spacious pushback seating, strong air conditioning, smooth suspension, charging points, music system, and ample luggage space, ensuring a relaxed and safe journey for all passengers. Suitable for 15–17 passengers, our Urbania hire service is ideal for groups who want to travel together in a single luxury vehicle with convenience and style. Shivai Travels provides experienced drivers, well-maintained vehicles, flexible rental plans, doorstep pickup and drop, and 24/7 customer support, making it one of the most dependable choices for Urbania rental service in Pune.",

"topPlaces": [

  {
    "title": "Goa",
    "description":
      "Goa is the top long-distance travel destination from Pune, known for beaches, nightlife, water sports, and resorts, ideal for luxury Urbania group trips."
  },

    {
    "title": "Lonavala & Khandala",
    "description":
      "Lonavala and Khandala are the most popular hill stations near Pune known for scenic valleys, waterfalls, forts, and monsoon views, perfect for Urbania group trips."
  },
  {
    "title": "Mahabaleshwar & Panchgani",
    "description":
      "Mahabaleshwar and Panchgani are famous hill stations known for strawberries, viewpoints, lakes, and cool weather, ideal for comfortable group travel."
  },
  {
    "title": "Shirdi",
    "description":
      "Shirdi is a major pilgrimage destination dedicated to Sai Baba, frequently visited by devotees traveling in Urbania rentals from Pune."
  },
  {
    "title": "Nashik & Trimbakeshwar",
    "description":
      "Nashik is known for religious tourism, vineyards, and Trimbakeshwar Jyotirlinga, making it a popular group travel destination."
  },
  {
    "title": "Alibaug",
    "description":
      "Alibaug is a coastal getaway near Mumbai known for beaches, forts, and resorts, ideal for weekend group trips from Pune."
  },
  {
    "title": "Konkan Beaches (Murud, Kashid, Diveagar)",
    "description":
      "Konkan beaches are known for scenic coastal roads, clean beaches, and peaceful environment, perfect for group road trips."
  },
  {
    "title": "Ajanta & Ellora Caves",
    "description":
      "Ajanta and Ellora Caves are UNESCO World Heritage Sites near Aurangabad known for ancient rock-cut architecture and cultural heritage tours."
  },
  {
    "title": "Pune City Sightseeing",
    "description":
      "Urbania is also widely used for Pune city tours covering Shaniwar Wada, Dagdusheth Temple, Aga Khan Palace, and Sinhagad Fort."
  },
  {
    "title": "Lavasa",
    "description":
      "Lavasa is a planned hill city near Pune known for lakeside views, modern architecture, and peaceful group picnic experiences."
  }
],



services: [
  {
    name: "Urbania Hire Pune",
    description: "Urbania hire Pune service provides premium and spacious transportation for airport transfers, family trips, corporate travel, sightseeing tours, weddings, and outstation journeys. Luxury Force Urbania vehicles with experienced drivers ensure smooth and safe travel for local and long-distance routes. Pickup services are available from homes, hotels, railway stations, offices, and airport terminals across Pune. Vehicles offer pushback seating, air conditioning, premium interiors, and luggage space suitable for executive and family travel requirements. Flexible booking options allow convenient Urbania hire reservations in Pune."
  },
  {
    name: "Pune Urbania Rental Service",
    description: "Pune Urbania rental service offers dependable transportation solutions for travelers seeking comfortable group travel within Pune and nearby destinations. Vehicles provide spacious seating and smooth highway travel suitable for tourism, corporate outings, airport travel, and family vacations. Professional chauffeurs ensure punctual pickup and safe driving services throughout the journey. Pickup services are available across Pune including homes, hotels, offices, railway stations, and airports. Flexible booking options allow convenient Urbania rental reservations."
  },
  {
    name: "Urbania Cab Hire Pune",
    description: "Urbania cab hire Pune service provides affordable and comfortable travel options for local and outstation journeys. Travelers can enjoy smooth trips with experienced drivers familiar with city roads, highways, and tourist destinations. Vehicles ensure spacious seating and safe transportation suitable for business trips, family vacations, and airport travel. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient Urbania cab hire reservations."
  },
  {
    name: "Force Urbania Taxi Pune",
    description: "Force Urbania taxi Pune service provides high-end transportation for passengers seeking comfortable and stylish group travel. Vehicles offer spacious seating, premium interiors, luggage capacity, and smooth ride quality suitable for tourism, wedding events, and executive travel. Professional drivers ensure safe driving and timely pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient Force Urbania taxi reservations."
  },
  {
    name: "Cheap Urbania Hire Pune",
    description: "Cheap Urbania hire Pune service offers economical and comfortable transportation for groups traveling within Pune and nearby destinations. Vehicles provide smooth highway travel with spacious seating suitable for one-day tours, airport transfers, and group outings. Professional drivers ensure punctual pickup and safe driving services throughout the trip. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient affordable Urbania reservations."
  },
  {
    name: "Luxury Urbania Hire Pune",
    description: "Luxury Urbania hire Pune service provides comfortable transportation for families, corporate teams, and tourists traveling within Pune and outstation destinations. Vehicles ensure smooth highway travel with spacious seating and luggage capacity suitable for tourism, pilgrimage tours, and weekend trips. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available across Pune including homes, hotels, offices, railway stations, and airports. Flexible booking options allow convenient luxury Urbania reservations."
  },
  {
    name: "Urbania Booking Service Pune",
    description: "Urbania booking service Pune offers spacious transportation for family tours, corporate outings, weddings, and sightseeing trips. Vehicles provide comfortable seating, air conditioning, and smooth highway performance suitable for long-distance journeys and executive travel. Professional chauffeurs ensure safe driving and timely pickup services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient Urbania booking service reservations."
  },
  {
    name: "Urbania Airport Cab Pune",
    description: "Urbania airport cab Pune service provides reliable transportation for airport pickup and drop services from Pune Airport and nearby locations. Vehicles offer spacious seating, luggage space, and comfortable travel suitable for family groups, corporate teams, and tourist travelers. Professional drivers ensure smooth travel and dependable pickup services throughout the trip. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient airport Urbania reservations."
  },
  {
    name: "Urbania Outstation Hire Pune",
    description: "Urbania outstation hire Pune service provides dependable transportation for long-distance group travel from Pune to tourist destinations, pilgrimage places, beaches, and hill stations. Comfortable vehicles ensure smooth highway travel suitable for tourism, corporate tours, and family vacations. Professional chauffeurs ensure safe driving and reliable transportation services throughout the journey. Pickup services are available across Pune including homes, hotels, railway stations, and airports. Flexible booking options allow convenient outstation Urbania reservations."
  },
  {
    name: "Urbania One Way Cab Pune",
    description: "Urbania one way cab Pune service offers spacious and comfortable transportation for one-side travel from Pune to nearby cities and tourist destinations. Vehicles provide comfortable seating and luggage space suitable for family groups, business teams, and tourist travelers. Professional drivers ensure punctual transfers and safe transportation services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient one-way Urbania reservations."
  },
  {
    name: "Urbania Round Trip Pune",
    description: "Urbania round trip Pune service offers premium transportation for sightseeing tours, family vacations, pilgrimage journeys, and business travel with return options. Vehicles ensure comfortable seating and smooth travel suitable for large family groups and corporate outings. Professional chauffeurs ensure safe driving and timely pickup services for all travel requirements. Pickup services are available from homes, hotels, banquet halls, railway stations, and airports across Pune. Flexible booking options allow convenient round trip Urbania reservations."
  },
  {
    name: "Best Urbania Service Pune",
    description: "Best Urbania service Pune offers reliable group transportation for airport pickup and drop services, sightseeing tours, and outstation travel. Vehicles provide spacious seating and luggage space suitable for family groups, corporate teams, and tourist travelers. Professional drivers ensure punctual transfers and safe transportation services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient best Urbania service reservations."
  },
  {
    name: "Urbania with Driver Pune",
    description: "Urbania with driver Pune service provides complete luxury transportation solutions for local and outstation group travel requirements. Vehicles ensure smooth highway travel suitable for tourism, corporate events, pilgrimage tours, and family vacations. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Urbania with driver reservations."
  },
  {
    name: "Family Urbania Hire Pune",
    description: "Family Urbania hire Pune service offers comfortable and dependable transportation with modern vehicles and experienced chauffeurs. Vehicles are suitable for family trips, sightseeing tours, airport transfers, corporate outings, and long-distance travel. Professional drivers ensure safe driving and reliable transportation services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient family Urbania reservations."
  },
  {
    name: "Premium Urbania Cab Pune",
    description: "Premium Urbania cab Pune service provides luxury transportation for groups looking for premium travel experiences with spacious seating and comfortable interiors. Vehicles are suitable for corporate events, destination outings, sightseeing trips, airport travel, and family tours. Professional chauffeurs ensure smooth journeys and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient premium Urbania cab reservations."
  }
],

tableData: [
  ["Urbania Hire Pune", "Pune Urbania Rental Service"],
  ["Urbania Cab Hire Pune", "Force Urbania Taxi Pune"],
  ["Cheap Urbania Hire Pune", "Luxury Urbania Hire Pune"],
  ["Urbania Booking Service Pune", "Urbania Airport Cab Pune"],
  ["Urbania Outstation Hire Pune", "Urbania One Way Cab Pune"],
  ["Urbania Round Trip Pune", "Best Urbania Service Pune"],
  ["Urbania with Driver Pune", "Family Urbania Hire Pune"],
  ["Premium Urbania Cab Pune", "Urbania Hire Pune"]
],


 whychoose: [
      {
        WhyChooseheading: "Reliable Urbania Hire in Pune",
        WhyChoosedescription: "Shivai Travels provides reliable Urbania hire service in Pune with professional drivers, luxury seating, and punctual pickup for smooth and comfortable group travel experiences."
      },
      {
        WhyChooseheading: "Affordable Urbania Hire Pricing",
        WhyChoosedescription: "Shivai Travels offers affordable Urbania hire in Pune with transparent pricing and no hidden charges. Customers receive complete fare details before confirming their booking."
      },
      {
        WhyChooseheading: "24/7 Urbania Vehicle Availability",
        WhyChoosedescription: "Our Urbania hire service in Pune operates 24 hours a day for airport transfers, family tours, corporate outings, weddings, pilgrimage trips, and emergency transportation requirements."
      },
      {
        WhyChooseheading: "Luxury & Comfortable AC Urbania Vehicles",
        WhyChoosedescription: "All Urbania vehicles provided by Shivai Travels are fully air-conditioned, sanitized, spacious, and regularly maintained to provide premium comfort during local and long-distance travel."
      },
      {
        WhyChooseheading: "One Way & Round Trip Urbania Booking",
        WhyChoosedescription: "Shivai Travels offers flexible travel options including one-way Urbania booking, round-trip travel, airport transfers, local sightseeing, and customized outstation travel packages."
      },
      {
        WhyChooseheading: "Ideal Vehicle for Family & Group Travel",
        WhyChoosedescription: "Our Urbania vehicles are ideal for family vacations, corporate teams, wedding groups, tourists, school trips, and VIP travel with spacious seating and luggage capacity."
      },
      {
        WhyChooseheading: "Doorstep Pickup Across Pune",
        WhyChoosedescription: "Shivai Travels provides convenient pickup from homes, offices, hotels, Pune Airport, railway stations, and all major Pune areas including Baner, Wakad, Hinjewadi, Kharadi, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Drivers for Local & Outstation Routes",
        WhyChoosedescription: "Our experienced drivers are familiar with Pune city routes, highways, hill stations, Konkan roads, and interstate destinations, ensuring safe driving and smooth travel for every journey."
      }
    ]
  };

  const faqData = [
    { question: "What is Urbania hire service in Pune?", answer: "Urbania hire service in Pune provides luxury group transportation for family tours, corporate travel, weddings, airport transfers, sightseeing trips, and outstation journeys." },
    { question: "Is Urbania hire in Pune available 24 hours?", answer: "Yes, Shivai Travels provides 24/7 Urbania hire service in Pune." },
    { question: "Which Urbania seating options are available?", answer: "Shivai Travels offers 10 seater, 13 seater, and 17 seater Urbania vehicles." },
    { question: "Can I book Urbania for outstation travel?", answer: "Yes, customers can book Urbania vehicles for local sightseeing, airport transfers, family tours, corporate trips, and outstation travel." },
    { question: "Do you provide one-way and round-trip Urbania service?", answer: "Yes, Shivai Travels provides both one-way and round-trip Urbania booking services." },
    { question: "Are all Urbania vehicles air-conditioned?", answer: "Yes, all Urbania vehicles are fully air-conditioned and maintained for comfortable luxury travel." },
    { question: "Can I book Urbania hire in Pune online?", answer: "Yes, customers can easily book Urbania hire service online or through phone booking." },
    { question: "Do you provide Urbania vehicles for weddings and corporate events?", answer: "Yes, Shivai Travels provides Urbania vehicles for weddings, corporate outings, airport transfers, and family group travel." },
    { question: "Are Urbania hire fares transparent?", answer: "Yes, Shivai Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for Urbania hire in Pune?", answer: "Yes, advance booking is available and recommended during weekends, holidays, wedding seasons, and peak travel periods." }
  ];

  const testimonials = [
    {
      id: 1,
      name: "Mr. Akshay Patil",
      feedback:
        "Booked Urbania hire in Pune with Shivai Travels. Luxury vehicle, smooth journey, and excellent driver support for our group tour.",
      rating: 5
    },
    {
      id: 2,
      name: "Mrs. Snehal Kulkarni",
      feedback:
        "Excellent Urbania hire service in Pune. Affordable pricing, clean luxury vehicle, and wonderful group travel experience.",
      rating: 5
    }
  ];





  

  const Images = [
    { place: "/images/keyword/1.jpg", text: "Pune Outstation Cab Service", link: "Pune-Outstation-Cab-Service" },
    { place: "/images/keyword/2.jpg", text: "Pune Taxi Service", link: "Pune-Taxi-Service" },
    { place: "/images/keyword/3.jpg", text: "Pune Cab Booking", link: "Pune-Cab-Booking" },
    { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    { place: "/images/keyword/6.jpg", text: "Cheap Cabs in Pune", link: "Cheap-Cabs-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
    { place: "/images/keyword/8.jpg", text: "Corporate Cab Service Pune", link: "Corporate-Cab-Service-Pune" },
    { place: "/images/keyword/9.jpg", text: "Pune Airport Cab", link: "Pune-Airport-Cab" },
    { place: "/images/keyword/10.jpg", text: "Pune Railway Station Cab Service", link: "Pune-Railway-Station-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Pune One Way Cab Service", link: "Pune-One-Way-Cab-Service" },
    { place: "/images/keyword/12.jpg", text: "Pune Local and Outstation Cab", link: "Pune-Local-and-Outstation-Cab" },
    { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/15.jpg", text: "Pune to Nashik Cab Service", link: "Pune-to-Nashik-Cab-Service" },
    { place: "/images/keyword/16.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
    { place: "/images/keyword/17.jpg", text: "Pune to Kolhapur Cab", link: "Pune-to-Kolhapur-Cab" },
    { place: "/images/keyword/18.jpg", text: "Pune to Solapur Cab Service", link: "Pune-to-Solapur-Cab-Service" },
    { place: "/images/keyword/19.jpg", text: "Pune to Ahmednagar Taxi", link: "Pune-to-Ahmednagar-Taxi" },
    { place: "/images/keyword/20.jpg", text: "Pune to Sangli Cab", link: "Pune-to-Sangli-Cab" },
    { place: "/images/keyword/21.jpg", text: "Pune to Satara Cab Service", link: "Pune-to-Satara-Cab-Service" },
    { place: "/images/keyword/22.jpg", text: "Pune to Jalgaon Cab Service", link: "Pune-to-Jalgaon-Cab-Service" },
    { place: "/images/keyword/23.jpg", text: "Pune to Dhule Cab Service", link: "Pune-to-Dhule-Cab-Service" },
    { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
    { place: "/images/keyword/25.jpg", text: "Pune to Panvel Cab", link: "Pune-to-Panvel-Cab" },

  ];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania Hire in Pune",
  "image": "https://shivaitravels.com/assets/images/urbania-hire-pune.jpg",
  "description": "Book Urbania hire in Pune with Shivai Travels for comfortable, spacious, and premium group travel. Ideal for airport transfers, family trips, corporate travel, and outstation journeys. Available with AC comfort, professional driver, and flexible one-way and round-trip booking options.",
  "brand": {
    "@type": "Brand",
    "name": "Shivai Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹28/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://shivaitravels.com/urbania-hire-pune"
  }
};



  return (
    <div>


<Helmet>
  <title>Urbania Hire in Pune | Luxury & Premium Cab Service | Shivai Travels | +91 9689815477</title>

  <meta
    name="description"
    content="Book Urbania hire in Pune with Shivai Travels. Premium AC Urbania cab service for airport transfers, outstation trips, family travel, and corporate bookings. Available with driver 24x7."
  />

  <meta
    name="keywords"
    content="urbania hire pune, pune urbania rental service, urbania cab hire pune, force urbania taxi pune, cheap urbania hire pune, luxury urbania hire pune, urbania booking service pune, urbania airport cab pune, urbania outstation hire pune, urbania one way cab pune, urbania round trip pune, best urbania service pune, urbania with driver pune, family urbania hire pune, premium urbania cab pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>





      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title text-white"> {cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </div>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/1.png' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#3F1B0D', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Shivai Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shivai Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shivai Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919689815477" className="pc-call">+91 9689815477</a>
                    </div>

                    <div className="pc-cta">
                    <a
  href="https://wa.me/919689815477?text=Welcome%20to%20Shivai%20Travels!%20%F0%9F%9A%8C%0AWe%20are%20happy%20to%20assist%20you%20with%20comfortable%20and%20safe%20travel%20services.%20Please%20let%20us%20know%20how%20we%20can%20help%20you."
  target="_blank"
  rel="noopener noreferrer"
  className="pc-whats"
>
  <i className="bi bi-whatsapp"></i> WhatsApp
</a>
                      <a href="tel:+919689815477" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shivaitravels.com" className="pc-email">
                      booking@shivaitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shivai Travels</strong><br />
                      Shop no 1, Kamdhenu nagar, Guru mauli society, Vadgaon road, Near super bazar, Alandi, Pune 412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Urbaniahireinpune;